'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FaFilter from 'react-icons/lib/fa/filter';
import FaClose from 'react-icons/lib/fa/close';
import FilterItem from './FilterItem';
import ReactDOM from "react-dom";

import { Manager, Reference, Popper } from 'react-popper';

var FilterDropdown = function (_Component) {
  _inherits(FilterDropdown, _Component);

  function FilterDropdown(props) {
    _classCallCheck(this, FilterDropdown);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.filterDomElement = null;

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  FilterDropdown.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    document.addEventListener('click', function (e) {
      return _this2.handleClick(e);
    }, false);
  };

  FilterDropdown.prototype.componentWillUnmount = function componentWillUnmount() {};

  FilterDropdown.prototype.handleClick = function handleClick(e) {
    try {
      this.filterDomElement = ReactDOM.findDOMNode(this);

      // outside the panel
      if (!this.filterDomElement.contains(e.target)) {
        // close if the panel was open
        if (this.state.isOpen) {
          this.setState({
            isOpen: false
          });
        }

        // inside the panel
      } else {
        this.setState({
          isOpen: true
        });
      }
    } catch (error) {}
  };

  FilterDropdown.prototype.buildMenu = function buildMenu() {
    var _this3 = this;

    var menu = [];
    var count = 0;

    var filters = this.props.filters;

    // used to show an ordered list of filters
    var orderedArray = Array.from(filters.keys());
    orderedArray.sort();

    orderedArray.forEach(function (filter) {
      menu.push(React.createElement(FilterItem, { key: count++, filters: filters, filter: filter, selected: filters.get(filter), filterHandler: _this3.props.filterHandler }));
    });

    return function (_ref) {
      var ref = _ref.ref,
          style = _ref.style,
          placement = _ref.placement;
      return React.createElement(
        'div',
        { className: 'ontology-ribbon__filter__list', ref: ref, style: style, 'data-placement': placement },
        React.createElement(
          'span',
          { className: 'checkbox', onClick: function onClick() {
              return _this3.props.filterHandler("all", true);
            } },
          'All'
        ),
        React.createElement(
          'span',
          { className: 'checkbox', style: { margin: ".5rem 0px" }, onClick: function onClick() {
              return _this3.props.filterHandler("all", false);
            } },
          'Clear'
        ),
        menu
      );
    };
  };

  FilterDropdown.prototype.render = function render() {
    var menu = this.buildMenu();

    var arrow = function arrow(_ref2) {
      var ref = _ref2.ref;
      return React.createElement(
        'span',
        { ref: ref },
        React.createElement(FaFilter, { className: 'filter-evidence-icon' })
      );
    };

    var modifiers = {
      hide: { enabled: false },
      preventOverflow: { enabled: false },
      flip: { enabled: false }
    };

    var pop = React.createElement(
      Popper,
      { modifiers: modifiers, placement: 'bottom', positionFixed: true },
      menu
    );

    return React.createElement(
      'div',
      { style: { fontWeight: 'bold', width: '10%' } },
      React.createElement(
        Manager,
        null,
        'Evidence \xA0 ',
        React.createElement(
          Reference,
          null,
          arrow
        ),
        this.state.isOpen && pop
      )
    );
  };

  return FilterDropdown;
}(Component);

FilterDropdown.propTypes = process.env.NODE_ENV !== "production" ? {
  filters: PropTypes.object.isRequired,
  // counts: PropTypes.object.isRequired,
  fireChangeEvent: PropTypes.func
} : {};

export default FilterDropdown;